import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=57be2a91&"
var script = {}
import style0 from "./Detail.vue?vue&type=style&index=0&id=57be2a91&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports